export default __webpack_public_path__ + "static/media/infoBlue.e02ec0f7.svg";